(() => {
  if (window.WhSpulserviceCart) return;

  const configElement = document.getElementById('WhSpulserviceCartConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const messages = config.messages;
  const root = window.Shopify.routes.root;
  const serviceProductId = Number(config.serviceProductId);
  const serviceVariants = config.serviceVariants;
  const checkoutSelector = 'cart-form [name="checkout"], cart-form .checkout-buttons a, cart-form a[href*="/checkout"], cart-form .additional-checkout-buttons';
  const dirty = new Map();
  let tail = Promise.resolve();
  let pending = 0;
  let debounceTimer;
  let blocked = false;
  let lastCart = null;
  let notice = '';
  let issues = [];
  let checkoutRunning = false;
  let checkoutBypass = false;
  let refreshPending = false;

  const props = (item) => item.properties || {};
  const isService = (item) => Number(item.product_id) === serviceProductId;
  const isParent = (item) => Boolean(props(item)._wh_spul_group && props(item)._wh_spul_role !== 'service');
  const hasSpulservice = () => Boolean(blocked || pending > 0 || dirty.size > 0 || document.querySelector('[data-wh-spul-group]') || lastCart?.items.some((item) => isParent(item) || isService(item)));
  const busy = () => pending > 0 || dirty.size > 0;

  async function request(path, body) {
    const response = await fetch(`${root}${path}`, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400) {
      const error = new Error(typeof result.description === 'string' ? result.description : messages.error);
      error.status = response.status;
      throw error;
    }
    return result;
  }

  function inspect(cart) {
    const findings = [];
    const parents = cart.items.filter(isParent);
    const children = cart.items.filter(isService);
    parents.forEach((parent) => {
      const group = props(parent)._wh_spul_group;
      const parts = String(props(parent)._wh_spul_parts);
      const expected = Number(serviceVariants[parts]);
      const matches = children.filter((child) => props(child)._wh_spul_group === group && child.parent_relationship?.parent_key === parent.key);
      if (parents.filter((item) => props(item)._wh_spul_group === group).length !== 1 || !expected || Number(props(parent)._wh_spul_service_variant) !== expected || matches.length !== 1) {
        findings.push({ type: 'incomplete', group });
        return;
      }
      const child = matches[0];
      if (Number(child.variant_id) !== expected || props(child)._wh_spul_role !== 'service') {
        findings.push({ type: 'incomplete', group });
      } else if (child.quantity !== parent.quantity) {
        findings.push({ type: 'quantity', group, childKey: child.key, quantity: parent.quantity });
      }
    });
    children.forEach((child) => {
      const parent = parents.find((item) => item.key === child.parent_relationship?.parent_key && props(item)._wh_spul_group === props(child)._wh_spul_group);
      if (!parent) findings.push({ type: 'incomplete', group: props(child)._wh_spul_group || '' });
    });
    return findings;
  }

  async function verifyCart() {
    let cart = await request('cart.js');
    let findings = inspect(cart);
    const maximumRepairs = cart.items.length;
    for (let repair = 0; repair < maximumRepairs; repair += 1) {
      const mismatch = findings.find((finding) => finding.type === 'quantity');
      if (!mismatch) break;
      cart = await request('cart/change.js', { id: mismatch.childKey, quantity: mismatch.quantity });
      const next = inspect(cart);
      if (next.some((finding) => finding.type === 'quantity' && finding.group === mismatch.group)) {
        findings = next;
        break;
      }
      findings = next;
    }
    lastCart = cart;
    issues = findings;
    blocked = findings.length > 0;
    return cart;
  }

  function renderStatus() {
    const active = hasSpulservice() || Boolean(notice);
    document.querySelectorAll('cart-form').forEach((form) => {
      let region = form.querySelector('.wh-spul-cart-status');
      if (!region && active) {
        region = document.createElement('div');
        region.className = 'wh-spul-cart-status';
        region.setAttribute('role', 'status');
        region.setAttribute('aria-live', 'polite');
        const text = document.createElement('span');
        text.className = 'wh-spul-cart-status__text';
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'wh-spul-cart-status__retry';
        retry.textContent = messages.retry;
        retry.addEventListener('click', () => run(async () => {}).catch(() => {}));
        region.append(text, retry);
        form.prepend(region);
      }
      if (!region) return;
      const content = busy() ? messages.updating : blocked ? messages.incomplete : notice;
      region.hidden = !content;
      region.querySelector('.wh-spul-cart-status__text').textContent = content;
      region.querySelector('button').hidden = busy() || !(blocked || notice);
      region.dataset.state = blocked ? 'error' : 'status';
    });
    const gated = active && (busy() || blocked);
    document.querySelectorAll(checkoutSelector).forEach((control) => {
      if (gated) {
        if (!control.hasAttribute('data-wh-spul-gated')) {
          control.dataset.whSpulGated = 'true';
          control.dataset.whSpulPreviousAria = control.getAttribute('aria-disabled') || '';
        }
        control.setAttribute('aria-disabled', 'true');
        control.classList.add('wh-spul-checkout-gated');
      } else if (control.hasAttribute('data-wh-spul-gated')) {
        const previous = control.dataset.whSpulPreviousAria;
        previous ? control.setAttribute('aria-disabled', previous) : control.removeAttribute('aria-disabled');
        control.removeAttribute('data-wh-spul-gated');
        control.removeAttribute('data-wh-spul-previous-aria');
        control.classList.remove('wh-spul-checkout-gated');
      }
    });
  }

  function refresh() {
    if (refreshPending) return;
    refreshPending = true;
    queueMicrotask(() => {
      refreshPending = false;
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    });
  }

  function enqueue(operation) {
    pending += 1;
    notice = '';
    renderStatus();
    const task = tail.catch(() => {}).then(async () => {
      let result;
      let operationError;
      try {
        result = await operation();
      } catch (error) {
        operationError = error;
      }
      try {
        await verifyCart();
      } catch (error) {
        blocked = true;
        issues = [{ type: 'unverified' }];
        operationError = operationError || error;
        try {
          lastCart = await request('cart.js');
          issues = inspect(lastCart);
          blocked = issues.length > 0;
        } catch (_) {
          blocked = true;
        }
      }
      if (operationError) {
        notice = operationError.message || messages.error;
        throw operationError;
      }
      if (blocked) {
        notice = messages.incomplete;
        throw new Error(messages.incomplete);
      }
      return result;
    }).finally(() => {
      pending -= 1;
      renderStatus();
      refresh();
    });
    tail = task.catch(() => {});
    return task;
  }

  function flushDirty() {
    clearTimeout(debounceTimer);
    if (!dirty.size) return tail;
    const changes = [...dirty.values()];
    dirty.clear();
    return enqueue(async () => {
      let firstError;
      for (const change of changes) {
        try {
          const cart = await request('cart.js');
          const item = change.group
            ? cart.items.find((candidate) => isParent(candidate) && props(candidate)._wh_spul_group === change.group)
            : cart.items.find((candidate) => candidate.key === change.key);
          if (!item) continue;
          if (isService(item)) {
            const parentExists = cart.items.some((candidate) => candidate.key === item.parent_relationship?.parent_key);
            if (change.quantity !== 0 || parentExists) continue;
          }
          if (item.quantity !== change.quantity) await request('cart/change.js', { id: item.key, quantity: change.quantity });
        } catch (error) {
          firstError = firstError || error;
        }
      }
      if (firstError) throw firstError;
    });
  }

  function run(operation) {
    flushDirty().catch(() => {});
    return enqueue(operation);
  }

  function adjustItemQuantity(form, row, adjustment) {
    if (!hasSpulservice()) return false;
    if (!row) return true;
    if (row.dataset.whSpulRole === 'service' && (row.dataset.whSpulParentKey || adjustment.to !== 0)) return true;
    if (pending > 0 || checkoutRunning) {
      notice = messages.locked;
      renderStatus();
      return true;
    }
    const input = row.querySelector('.cart-item__quantity-input');
    if (!input) return true;
    let quantity = Number(input.value);
    if (adjustment.to !== undefined) quantity = Number(adjustment.to);
    else if (adjustment.increase) quantity += 1;
    else if (adjustment.decrease) quantity -= 1;
    if (!Number.isFinite(quantity) || !Number.isInteger(quantity) || input.value.trim() === '') {
      input.value = input.dataset.initialValue;
      notice = messages.quantity_error;
      renderStatus();
      return true;
    }
    quantity = Math.max(0, quantity);
    const maximum = Number(input.max);
    if (input.max !== '' && Number.isFinite(maximum)) quantity = Math.min(quantity, maximum);
    input.value = String(quantity);
    const group = row.dataset.whSpulRole === 'parent' ? row.dataset.whSpulGroup : '';
    dirty.set(group || input.dataset.key, { group, key: input.dataset.key, quantity });
    notice = '';
    renderStatus();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => flushDirty().catch(() => {}), quantity === 0 ? 0 : 250);
    return true;
  }

  async function beforeCheckout(proceed) {
    if (checkoutRunning) return;
    checkoutRunning = true;
    try {
      await flushDirty();
      await enqueue(async () => {});
      if (blocked || busy()) return;
      checkoutBypass = true;
      proceed();
    } catch (_) {
      renderStatus();
      document.querySelector('.wh-spul-cart-status:not([hidden])')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    } finally {
      checkoutBypass = false;
      checkoutRunning = false;
    }
  }

  function activateCheckout(control, owner) {
    const current = control.isConnected ? control : owner?.querySelector('[name="checkout"], .checkout-buttons a, a[href*="/checkout"]');
    if (!current) return;
    const form = current.form || current.closest('form');
    const updates = form ? [...form.querySelectorAll('[name="updates[]"], [name^="updates["]')] : [];
    const originalStates = updates.map((input) => input.disabled);
    updates.forEach((input) => { input.disabled = true; });
    current.click();
    setTimeout(() => updates.forEach((input, index) => { input.disabled = originalStates[index]; }), 0);
  }

  document.addEventListener('click', (event) => {
    if (checkoutBypass || !hasSpulservice()) return;
    const control = event.target.closest?.(checkoutSelector);
    if (!control) return;
    const owner = control.closest('cart-form');
    event.preventDefault();
    event.stopImmediatePropagation();
    if (control.matches('.additional-checkout-buttons')) {
      if (!busy() && !blocked) {
        const checkout = control.closest('cart-form').querySelector('[name="checkout"], .checkout-buttons a, a[href*="/checkout"]');
        if (checkout) beforeCheckout(() => activateCheckout(checkout, owner));
      }
      return;
    }
    beforeCheckout(() => activateCheckout(control, owner));
  }, true);

  document.addEventListener('submit', (event) => {
    if (checkoutBypass || !hasSpulservice() || !event.target.closest('cart-form')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const form = event.target;
    const owner = form.closest('cart-form');
    const submitter = event.submitter || form.querySelector('[name="checkout"]');
    beforeCheckout(() => {
      if (submitter) activateCheckout(submitter, owner);
      else form.requestSubmit();
    });
  }, true);

  document.addEventListener('on:cart:after-merge', renderStatus);
  window.addEventListener('pageshow', () => {
    if (hasSpulservice()) run(async () => {}).catch(() => {});
  });

  window.WhSpulserviceCart = {
    run,
    flush: async () => { await flushDirty(); await tail; },
    adjustItemQuantity,
    getState: () => ({ busy: busy(), blocked, issues: [...issues], cart: lastCart })
  };
  if (hasSpulservice()) {
    blocked = true;
    run(async () => {}).catch(() => {});
  }
})();
